import 'react-dates/initialize';
import React, { useEffect, useState } from 'react';
import toMomentObject from 'react-dates/lib/utils/toMomentObject';
// import isSameDay from 'react-dates/lib/utils/isSameDay';
import get from 'lodash/get';
import moment from 'moment';
import { START_DATE, END_DATE } from 'react-dates/constants';

import DateRangePicker from '@guestyci/foundation/DatePicker/DateRangePicker';

const DatePicker = (props) => {
  const {
    onFocusChange,
    onClose,
    blockedDays,
    preloadInitialMonth,
    preloadNextMonth,
    startDate,
    endDate,
    disabled,
    hasError,
    enablePastDays,
    initialMonth,
  } = props;

  const [state, setState] = useState({
    value: {
      startDate: toMomentObject(startDate),
      endDate: toMomentObject(endDate),
    },
  });

  const [blockedDates, setBlockedDates] = useState(
    blockedDays?.length > 0
      ? blockedDays.map((day) => day.moment.format('YYYY-MM-DD'))
      : []
  );

  const [focusedInput, setFocusedInput] = useState(null);

  useEffect(() => {
    preloadInitialMonth();
  }, [preloadInitialMonth]);

  useEffect(() => {
    if (blockedDays?.length > 0) {
      let newBlockedDates;
      if (focusedInput === START_DATE) {
        newBlockedDates = blockedDays.map((day) =>
          day.moment.format('YYYY-MM-DD')
        );
      } else if (focusedInput === END_DATE) {
        newBlockedDates = blockedDays
          .map((day) => day.moment.add('days', 1).format('YYYY-MM-DD'))
          .filter((day) => day !== state.value.startDate.format('YYYY-MM-DD'));
      }
      setBlockedDates(newBlockedDates);
    }
  }, [blockedDays, focusedInput, state.value.startDate]);

  const handleFocusChange = (focusedIn) => {
    setFocusedInput(focusedIn || START_DATE);
    onFocusChange(focusedIn);
  };

  const handleOnClose = (...params) => {
    // We need close
    setFocusedInput(null);
    onClose(...params);
  };

  const onDatesChange = (data) => {
    const blockedDaysInRange = blockedDays.filter(
      (blocked) =>
        data.endDate &&
        blocked.moment.isBetween(
          data.startDate,
          data.endDate.clone().subtract(1, 'days')
        )
    ).length;
    hasError(blockedDaysInRange);
    setState({
      value: {
        startDate: toMomentObject(data.startDate),
        endDate: toMomentObject(data.endDate),
      },
    });
  };

  const placeholder = get(moment.localeData(), '_longDateFormat.L');

  let initialVisibleMonth = null;
  if (state.value.startDate) {
    initialVisibleMonth = state.value.startDate.format('YYYY-MM');
  } else if (initialMonth) {
    initialVisibleMonth = initialMonth.format('YYYY-MM');
  }

  return (
    <>
      <DateRangePicker
        value={state.value}
        endDateId={END_DATE}
        endDatePlaceholderText={placeholder}
        focusedInput={focusedInput}
        hideKeyboardShortcutsPanel
        minimumNights={1}
        onClose={handleOnClose}
        onChange={onDatesChange}
        onFocusChange={handleFocusChange}
        onNextMonthClick={preloadNextMonth}
        startDateId={START_DATE}
        startDatePlaceholderText={placeholder}
        disabled={disabled}
        enablePastDays={enablePastDays}
        showClearDate={false}
        initialVisibleMonth={initialVisibleMonth}
        blockedDates={blockedDates}
      />
    </>
  );
};

export default DatePicker;
